<template>
  <div class="login-container">
    <el-form
      autoComplete="on"
      :model="loginForm"
      :rules="loginRules"
      ref="loginForm"
      label-position="left"
      label-width="0px"
      class="card-box login-form"
    >
      <h3 class="title">NiceWork</h3>
      <el-form-item prop="username">
        <i class="el-icon-user" style="color: #fff;"></i>
        <el-input
          name="username"
          type="text"
          v-model="loginForm.userName"
          autoComplete="on"
          placeholder="手机号"
        />
      </el-form-item>
      <el-form-item prop="passwd">
        <i class="el-icon-lock" style="color: #fff;"></i>
        <el-input
            name="passwd"
            type="text"
            v-model="loginForm.passwd"
            @keyup.enter.native="handleLogin"
            autoComplete="off"
            placeholder="验证码"
        />
      </el-form-item>
        <el-button :disabled="disabled"
          type="danger"
          style="width:48%;"
          @click.native.prevent="getCode">
          获取验证码
        </el-button>
        <el-button
            type="primary"
            style="width:48%;"
            :loading="loading"
            @click.native.prevent="handleLogin">
          登录
        </el-button>
    </el-form>
  </div>
</template>

<script>
import {  mapActions } from "vuex";
import { getsmscode } from "@/api/user";

export default {
  name: "login",
  data() {
    const validateUsername = (rule, value, callback) => {
      if (value.length < 11) {
        callback(new Error("请输入正确手机号"));
      } else {
        callback();
      }
    };
    const validatePass = (rule, value, callback) => {
      if (value.length < 4) {
        callback(new Error("验证码不能小于4位"));
      } else {
        callback();
      }
    };
    return {
      disabled: false,
      loginForm: {
        userName: "",
        passwd: ""
      },
      loginRules: {
        userName: [
          { required: true, trigger: "blur", validator: validateUsername }
        ],
        password: [{ required: true, trigger: "blur", validator: validatePass }]
      },
      loading: false,
      pwdType: "passwd"
    };
  },
  mounted() {
    // if (
    //   window.location.host === "nicework.chenzhen.shop" &&
    //   window.location.protocol !== "https:"
    // ) {
    //   window.location = "https://nicework.chenzhen.shop/";
    // }
  },
  methods: {
    ...mapActions("system", ["login", "getSmsCode"]),
    showPwd() {
      if (this.pwdType === "passwd") {
        this.pwdType = "";
      } else {
        this.pwdType = "passwd";
      }
    },
    getCode() {
      getsmscode(this.loginForm.userName).then(() => {
        this.disabled=true
        this.$message({
          message: '验证码发送成功',
          type: 'success'
        });
      })
    },
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true;
          this.login(this.loginForm)
            .then(() => {
              this.loading = false;
              // this.$router.push({ path: "/" });
            })
            .catch(() => {
              this.loading = false;
            });
          // this.$store
          //   .dispatch("Login", this.loginForm)
          //   .then(() => {
          //     this.loading = false;
          //     this.$router.push({ path: "/" });
          //   })
          //   .catch(() => {
          //     this.loading = false;
          //   });
        } else {
          // console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
@import "./mixin.scss";
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;
.login-container {
  @include relative;
  height: 100vh;
  overflow: hidden;
  background-color: $bg;
  input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px #293444 inset !important;
    -webkit-text-fill-color: #fff !important;
  }
  input {
    background: transparent;
    border: 0px;
    -webkit-appearance: none;
    border-radius: 0px;
    padding: 12px 5px 12px 15px;
    color: $light_gray;
    height: 47px;
  }
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;
  }
  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;
  }
  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
    &_login {
      font-size: 20px;
    }
  }
  .title {
    font-size: 26px;
    font-weight: 400;
    color: $light_gray;
    margin: 0px auto 40px auto;
    text-align: center;
    font-weight: bold;
  }
  .login-form {
    width: 300px;
    padding: 35px 35px 15px 35px;
    margin: 120px auto 0;
  }
  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: #454545;
  }
  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }
  .thirdparty-button {
    position: absolute;
    right: 35px;
    bottom: 28px;
  }
}
</style>
